import { render, staticRenderFns } from "./addProjectDialog.vue?vue&type=template&id=53a567aa"
import script from "./addProjectDialog.vue?vue&type=script&lang=js"
export * from "./addProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./addProjectDialog.vue?vue&type=style&index=0&id=53a567aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports